import { BrowserRouter, Route, Link } from "react-router-dom";
import { Styled } from "./slyled";
function ServiceHome() {
  const serviceList = [
    {
      title: "Mandala Hotel 24/7",
      description:
        "Trái tim của Mandala, sự kết hợp táo bạo giữa không gian sảnh khách sạn, nhà hàng 24/7, không gian co-working tiện nghi và chill-bar thư thái khi đêm về.",
      thumbnail: "/images/playgame.png",
    },
    {
      title: "Tủ đồ cá nhân",
      description:
        "Nơi JO chủ động tắt'chế độ cồng kềnh', bật 'chế độ rảnh tay'.Vì lý do an toàn, Mandala vui lòng không cất hành lý qua đêm hoặc liên hệ GURU để được hỗ trợ. ",
      thumbnail: "/images/hotel2.png",
    },
    {
      title: "SHOP & GO",
      description:
        "Nơi Mandala có thể mua sắm bất kể ngày đêm. Đồ ăn, thức uống và vật dụng thiết yếu luôn sẵn sàng.",
      thumbnail: "/images/shopping.png",
    },
    {
      title: "Phòng thư giãn",
      description:
        "Để Mandala ngả lưng thư giãn trong thời gian chờ nhận phòng và ngay cả khi đã trả phòng.",
      thumbnail: "/images/relax.png",
    },
  ];
  return (
    <div id="serviceHome">
      <div className="container">
        <h5 className="titleStyle">...Thú vị hơn với</h5>
        <div className="serviceList">
          <div className="row">
            {serviceList.map((item, index) => {
              return (
                <div className="col-lg-6 col-12 col-md-6 serviceItem">
                  <div className="row serviceBox">
                    <div className="col-lg-6 col-12">
                      <h5>{item.title}</h5>
                      <p>{item.description}</p>
                    </div>
                    <div className="col-lg-6 col-12">
                      <img className="img-fluid" src={item.thumbnail} alt="" />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
          <Styled.Link>
            <Link to="/experiences">
              Và còn... <img src="/images/ic_arrow2.png" alt="" />
            </Link>
          </Styled.Link>
      </div>
    </div>
  );
}
export default ServiceHome;
